module.exports = __webpack_public_path__ + "static/media/lol-platinum.c0ad9404.png";